export const CONNECTIONS = 'CONNECTIONS';
